import { AdhocSupportedInterval } from 'constants/adhocSupportedInterval';
import { CrawlerRegistrationPayload } from 'api/crawlerApi';
import { CrawlerReleasedChannel } from 'constants/crawlerReleasedChannel';

/**
 * クローラー新規作成フォーム
 */
export type CrawlerRegistrationFormFields = {
  /** クローラーID */
  id: string;
  /** クローラー名 */
  name: string;
  /** イメージ名 */
  imageName: string;
  /** APIキーテンプレート */
  apiKeyTemplateId: string;
  /** バージョン */
  version: string;
  /** 説明 */
  description: string;
  /** リリース日 */
  releasedAt: Date | null;
  /** 手動実行対応 */
  adhocSupportedIntervals: AdhocSupportedInterval[];
  /** UI表示テンプレート */
  configTemplate: string;
  /** リリースチャンネル */
  releasedChannel: CrawlerReleasedChannel[];
};

export const createCrawlerRegistrationFormFields = ({
  id = '',
  name = '',
  imageName = '',
  apiKeyTemplateId = '',
  version = '',
  description = '',
  releasedAt = null,
  adhocSupportedIntervals = [],
  configTemplate = '',
  releasedChannel = [],
}: Partial<CrawlerRegistrationFormFields>): CrawlerRegistrationFormFields => ({
  id,
  name,
  imageName,
  apiKeyTemplateId,
  version,
  description,
  releasedAt,
  adhocSupportedIntervals,
  configTemplate,
  releasedChannel,
});

export const mapFormFieldsToCrawlerRegistrationPayload = ({
  id,
  name,
  imageName,
  apiKeyTemplateId,
  version,
  description,
  releasedAt,
  adhocSupportedIntervals,
  configTemplate,
  releasedChannel,
}: CrawlerRegistrationFormFields): CrawlerRegistrationPayload => ({
  id: /^\d+$/.test(id) ? parseInt(id, 10) : null,
  name,
  imageName,
  apiKeyTemplateId: /^\d+$/.test(apiKeyTemplateId)
    ? parseInt(apiKeyTemplateId, 10)
    : null,
  version,
  description,
  releasedAt: releasedAt instanceof Date ? releasedAt?.toISOString() : '',
  adhocSupportedIntervals,
  configTemplate,
  stable: releasedChannel.includes('stable'),
  beta: releasedChannel.includes('beta'),
});
